export default {
    users: {
        profile: {
            update_profile: 'The update was successful!',
            update_password: 'The password has been updated!',
        }
    }
}
